/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRotate2 = createReactComponent("outline", "rotate-2", "IconRotate2", [["path", { "d": "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5", "key": "svg-0" }], ["path", { "d": "M18.37 7.16l0 .01", "key": "svg-1" }], ["path", { "d": "M13 19.94l0 .01", "key": "svg-2" }], ["path", { "d": "M16.84 18.37l0 .01", "key": "svg-3" }], ["path", { "d": "M19.37 15.1l0 .01", "key": "svg-4" }], ["path", { "d": "M19.94 11l0 .01", "key": "svg-5" }]]);

export { IconRotate2 as default };
//# sourceMappingURL=IconRotate2.mjs.map
